// extracted by mini-css-extract-plugin
export default {"f":"_934c1a8028","main":"_9dcdc22322","btn":"_5ad59bd2fd","w":"_2c84be6cb1","h":"bba3febd36","lh25":"eaf651f6e9","wb":"_51c0dd57e7","b":"bf4f99e15a","bx":"_1d7a0d1268"};